import { createRoute } from "@tanstack/solid-router";
// FLAGS: the entire page is gated by the tutoring vertical (active org).
import { withFeatureGate } from "@/features/flags/feature-gate";
import { msg } from "@lingui/core/macro";
import { ClipboardCheck } from "@fleet/icons";
import { appRoute } from "./route";
import { useI18n } from "@/providers/i18n-provider";
import { PageContainer, PageHeader } from "@fleet/ui";
import { TutorPanel } from "@/features/academy/tutor/tutor-panel";
// AUTONOMY · Layer 3: tutoring contextual help.

function TutoringPage() {
  const { t } = useI18n();
  return (
    <PageContainer maxWidth="6xl">
      <div class="flex items-start justify-between gap-2">
        <PageHeader
          title={t(msg`Tutoring`)}
          description={t(
            msg`Review submissions from your cohorts against the SLA: return them with feedback or approve them. Students resubmit until approved.`,
          )}
          icon={ClipboardCheck}
        />
      </div>
      <div class="mt-4">
        <TutorPanel />
      </div>
    </PageContainer>
  );
}

export const academyTutoringRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/academy/tutoring",
  component: withFeatureGate("academy.tutoring", TutoringPage),
});
